import {VirtualElement} from '@floating-ui/react';
import {makeAutoObservable} from 'mobx';

import {ReferenceType} from 'modules/Tasks/components/Gantt/hooks/useHideContextOnGanttScroll';
import {GanttTask} from 'modules/Tasks/components/Gantt/types';
import {EditActionTypes} from 'modules/Tasks/components/Gantt/utils/constants';

import {GanttContextStoreType} from './types';

export class GanttContextMenuStore implements GanttContextStoreType {
  taskSelectorElementRef: ReferenceType = null;
  floatingMenuElementRef: VirtualElement = null;
  activeGanttTask: GanttTask = null;
  currentEditAction: EditActionTypes = null;

  constructor() {
    makeAutoObservable(this);
  }

  updateTaskSelectorRef = (elementRef: ReferenceType) => {
    this.taskSelectorElementRef = elementRef;
  };

  updateFloatingMenuRef = (elementRef: VirtualElement) => {
    this.floatingMenuElementRef = elementRef;
  };

  selectGanttTask = (task: GanttTask) => {
    this.activeGanttTask = task;
  };

  setActiveTask(task: GanttTask | null) {
    this.activeGanttTask = task;
  }

  resetContextMenuState() {
    if (this?.taskSelectorElementRef && this.taskSelectorElementRef) {
      this.activeGanttTask = null;
      this.taskSelectorElementRef = null;
      this.floatingMenuElementRef = null;
    }
  }
}
